module.exports = __webpack_public_path__ + "img/card-t7.a9aca82a.png";